import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { AnnouncementType } from "types/announcement";

import { extraReducers } from "./announcement.extraReducers";

const initialState: AnnouncementType = {
  isLoading: false,
  data: [],
  pageSize: 100,
  currentPage: 1,
  totalCount: 0,
  totalPages: 0,
  dataByType: [],
  homeData: [],
  isHomeLoading: false,
  hasFetchedHomeData: false,
  hasShownHomeModalAfterLogin: false,
};
const announcementSlice = createSlice({
  name: "announcement",
  initialState,
  reducers: {
    resetAnnouncement: () => initialState,
    setHasShownHomeModalAfterLogin: (state, action: PayloadAction<boolean>) => {
      state.hasShownHomeModalAfterLogin = action.payload;
    },
  },
  extraReducers,
});
export const selectIsLoading = (state: ApplicationRootState) =>
  state.announcement.isLoading;
export const selectAnnouncement = (state: ApplicationRootState) =>
  state.announcement.data;
export const selectAnnouncementByType = (state: ApplicationRootState) =>
  state.announcement.dataByType;
export const selectHomeAnnouncement = (state: ApplicationRootState) =>
  state.announcement.homeData;
export const selectHomeAnnouncementDetail = (state: ApplicationRootState) =>
  state.announcement.homeData[0];
export const selectIsHomeAnnouncementLoading = (state: ApplicationRootState) =>
  state.announcement.isHomeLoading;
export const selectHasFetchedHomeAnnouncement = (state: ApplicationRootState) =>
  state.announcement.hasFetchedHomeData;
export const selectHasShownHomeModalAfterLogin = (
  state: ApplicationRootState
) => state.announcement.hasShownHomeModalAfterLogin;
export const selectTotalPages = (state: ApplicationRootState) =>
  state.announcement.totalPages;
export const selectCurrentPages = (state: ApplicationRootState) =>
  state.announcement.currentPage;

export const { resetAnnouncement, setHasShownHomeModalAfterLogin } =
  announcementSlice.actions;

export default announcementSlice.reducer;
